"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResponseError_1 = require("../../Components/Http/Error/ResponseError");
const Druid_1 = require("../../Druid");
class ResponseHandler {
    constructor(aborted) {
        this.aborted = [];
        this.aborted = aborted;
    }
    handleResponse(requestData, responsePromise) {
        return new Promise((resolve, reject) => {
            responsePromise
                .then((response) => {
                // request was aborted
                if (this.aborted.includes(requestData)) {
                    reject(new DOMException('Request was aborted.', 'AbortError'));
                    return;
                }
                Druid_1.default.handleHttpResponse(response);
                if (response.ok) {
                    resolve(response);
                }
                else {
                    reject(new ResponseError_1.default('Request failed', response));
                }
            })
                .catch((responseError) => {
                // request was aborted (old style)
                if (this.aborted.includes(requestData)) {
                    reject(responseError);
                    return;
                }
                // request was aborted (new style)
                if (responseError instanceof DOMException && responseError.code === DOMException.ABORT_ERR) {
                    reject(responseError);
                    return;
                }
                // request failed
                Druid_1.default.handleHttpResponse(responseError);
                console.error(responseError);
                reject(responseError);
            });
        });
    }
}
exports.default = ResponseHandler;
//# sourceMappingURL=ResponseHandler.js.map